<template>
  <a v-if="link" v-bind:href="link" target="_blank">
    <b-icon-box-arrow-up-right variant="primary" class="mr-1" />
  </a>
</template>

<script>
export default {
  name: "ExternalLink",
  props: ["link"]
};
</script>
